import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { DataboxOfficialGridObject } from '@libs/types/src/inbox/object-type/databox-official.object';
import { databoxOfficialGridItemFrag } from './types/databox-official.gql-types';

@Injectable({ providedIn: 'root' })
export class DataboxOfficialGqlService extends GqlServiceV2 {
    getOfficialDataboxes(input: GridInput, frag: string = databoxOfficialGridItemFrag) {
        return this.query<DataboxOfficialGridObject>(
            `
                query($input: GridInput!) {
                    databoxOfficial {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
